<template>



    <div class="home">

        <div class="homebg" v-if="step == 0">
            <img src="../static/loding.gif" class="loding" alt="">
            <img src="../static/homebut.png" v-show="thebut" @click="tomp4" class="but" alt="">
        </div>

        <div class="mp4-box" v-show="step == 1">
            <video class="mp4" id="mp4" webkit-playsinline="false" x-webkit-airplay="false" playsinline="false"
                x5-video-player-type="h5" preload="Metadata" poster="../static/homestart.png" @click="ifplay"
                :loop="false">
                <source :src="video_mp4" type="video/mp4" />
            </video>

            <img src="@/static/skip.png" @click="skip"  class="skip" alt="" />



        </div>

        <div class="content-box" v-show="step == 2">
            <div class="content" id="content">
                <img src="@/static/music.png" :class="music ? 'music zhuan' : 'music'" @click="stopmusic"
                    v-show="step == 2" alt="" />
                <img src="../static/content_bg.jpg" id="contentbg" class="content_bg" alt="">
                <img src="../static/title.png" class="title" alt="">

                <img src="../static/tobottom.gif" class="tobottom" alt="">

                <img src="../static/the1.png" v-show="content_p1" class="the1" alt="">
                <img src="../static/p1-1.png" class="p1-1" v-show="content_p1_1" alt="">
                <img src="../static/p1-2.png" class="p1-2" v-show="content_p1_2" alt="">
                <img src="../static/p1-3.png" class="p1-3" v-show="content_p1_3" alt="">

                <img src="../static/the2.png" class="the2" v-show="content_p2" alt="">
                <img src="../static/p2-1.png" class="p2-1" v-show="content_p2_1" alt="">
                <div class="photo-box" v-show="content_p2_1">
                    <div class="box">
                        <img src="../static/p2-1-1.png" class="p2-1-1" alt=""></img>
                    </div>

                </div>
                <img src="../static/p2-2.png" class="p2-2" v-show="content_p2_2" alt="">
                <img src="../static/p2-3.png" class="p2-3" v-show="content_p2_3" alt="">

                <img src="../static/the3.png" class="the3" v-show="content_p3" alt="">
                <img src="../static/p3-1.png" class="p3-1" v-show="content_p3_1" alt="">

                <img src="../static/p3-2.png" class="p3-2" v-show="content_p3_2" alt="">
                <img src="../static/p3-3.png" class="p3-3" v-show="content_p3_3" alt="">
                <div class="photo-box2" v-show="content_p3_3">
                    <div class="box">
                        <img src="../static/p3-2-1.png" class="p3-2-1" alt=""></img>
                    </div>

                </div>

                <img src="../static/the4.png" class="the4" v-show="content_p4" alt="">
                <img src="../static/p4-1.png" class="p4-1" v-show="content_p4_1" alt="">
                <div class="photo-box3" v-show="content_p4_1">
                    <div class="box">
                        <img src="../static/p4-1-1.png" class="p4-1-1" alt=""></img>
                    </div>

                </div>
                <img src="../static/p4-2.png" class="p4-2" v-show="content_p4_2" alt="">

                 <img src="@/static/againbut.png" class="againbut"  @click="theagain" alt=""> 
            <img src="@/static/sharebut.png" class="sharebut"  @click="share_box=true" alt=""> 
                <img src="../static/theend.png" class="theend" alt="">
                <img src="../static/bottomlogo.png" class="bottomlogo" alt="">
                <div class="share-box" v-show="share_box" @click="share_box = false">
                    <img src="../static/share-tips.png" class="share-tips" alt="">
                </div>
            </div>

        </div>
        <audio id="audio" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
        <audio id="thepy" :src="require('@/static/show.mp3')"></audio>


    </div>
</template>

<script>


export default {

    data() {
        return {
            thebut: false,
            step: 0,
            video_mp4: require("@/static/startmp4.mp4"),
            // themp4: 1,
            // ifend: false,
            music: true,
            share_box: false,
            content_p1: false,
            content_p1_1: false,
            content_p1_2: false,
            content_p1_3: false,
            content_p2: false,
            content_p2_1: false,
            content_p2_2: false,
            content_p2_3: false,
            content_p3: false,
            content_p3_1: false,
            content_p3_2: false,
            content_p3_3: false,
            content_p4: false,
            content_p4_1: false,
            content_p4_2: false,
            content_p4_3: false,
        }
    },
    methods: {
        // showmp4() {
        //     this.step = 1
        //     this.themp4 = 2
        //     this.video_mp4 = require("@/static/startmp4.mp4")
        //     document.getElementById("mp4").play()

        // },
        scrolling() {
            // 滚动条距文档顶部的距离
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            // 滚动条滚动的距离
            let scrollStep = scrollTop - this.oldScrollTop;
            console.log("header 滚动距离 ", scrollTop,);

            // 更新——滚动前，滚动条距文档顶部的距离
            // this.oldScrollTop = scrollTop;

            //变量windowHeight是可视区的高度
            let windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            let scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight;

            // console.log(66,scrollTop,scrollHeight,windowHeight);

            //滚动条到底部的条件
            if (scrollTop + windowHeight >= scrollHeight - 2) {
                //你想做的事情
                console.log("header  你已经到底部了");


            }
            //   if (scrollStep < 0) {
            //     console.log("header 滚动条向上滚动了！");
            //   } else {
            //     console.log("header  滚动条向下滚动了！");
            //   }
            // 判断是否到了最顶部

            let bl = window.innerWidth / 375
            if (scrollTop > 50 * bl) {

                this.content_p1 = true

            } else {
                this.content_p1 = false

            }

            if (scrollTop > 250 * bl) {
                if (!this.content_p1_1) {
                    document.getElementById("thepy").play()
                }

                this.content_p1_1 = true
            } else {
                this.content_p1_1 = false
            }
            if (scrollTop > 550 * bl) {
                if (!this.content_p1_2) {
                    document.getElementById("thepy").play()
                }

                this.content_p1_2 = true
            } else {
                this.content_p1_2 = false
            }

            if (scrollTop > 800 * bl) {
                if (!this.content_p1_3) {
                    document.getElementById("thepy").play()
                }
                this.content_p1_3 = true
            } else {
                this.content_p1_3 = false
            }

            if (scrollTop > 1100 * bl) {
                this.content_p2 = true
            } else {
                this.content_p2 = false
            }

            if (scrollTop > 1500 * bl) {
                if (!this.content_p2_1) {
                    document.getElementById("thepy").play()
                }
                this.content_p2_1 = true
            } else {
                this.content_p2_1 = false
            }

            if (scrollTop > 1650 * bl) {
                if (!this.content_p2_2) {
                    document.getElementById("thepy").play()
                }
                this.content_p2_2 = true
            } else {
                this.content_p2_2 = false
            }

            if (scrollTop > 1750 * bl) {
                if (!this.content_p2_3) {
                    document.getElementById("thepy").play()
                }
                this.content_p2_3 = true
            } else {
                this.content_p2_3 = false
            }

            if (scrollTop > 2000 * bl) {
                this.content_p3 = true
            } else {
                this.content_p3 = false
            }

            if (scrollTop > 2550 * bl) {
                if (!this.content_p3_1) {
                    document.getElementById("thepy").play()
                }
                this.content_p3_1 = true
            } else {
                this.content_p3_1 = false
            }

            if (scrollTop > 2750 * bl) {
                if (!this.content_p3_2) {
                    document.getElementById("thepy").play()
                }
                this.content_p3_2 = true
            } else {
                this.content_p3_2 = false
            }

            if (scrollTop > 3100 * bl) {
                if (!this.content_p3_3) {
                    document.getElementById("thepy").play()
                }
                this.content_p3_3 = true
            } else {
                this.content_p3_3 = false
            }

            if (scrollTop > 3850 * bl) {
                this.content_p4 = true
            } else {
                this.content_p4 = false
            }

            if (scrollTop > 4000 * bl) {
                if (!this.content_p4_1) {
                    document.getElementById("thepy").play()
                }
                this.content_p4_1 = true
            } else {
                this.content_p4_1 = false
            }

            if (scrollTop > 4530 * bl) {
                if (!this.content_p4_2) {
                    document.getElementById("thepy").play()
                }
                this.content_p4_2 = true
            } else {
                this.content_p4_2 = false
            }




            if (scrollTop <= 0) {
                console.log("header 到了最顶部")
            }
        },
        tomp4() {
            this.step = 1
            document.getElementById("mp4").play()
        },
        ifplay() {
            const mp4 = document.getElementById("mp4");
            if (mp4.paused && mp4.currentTime != mp4.duration) {
                mp4.play();
            }
            else {
                mp4.pause();
            }
        },
        skip() {
            console.log("skip",);
            const mp4 = document.getElementById("mp4");
            mp4.play();
            if (mp4.currentTime != mp4.duration) {
                mp4.currentTime = mp4.duration - 0.1;
                // if (this.themp4==1) {
                //     this.step = 2
                // }else if(this.themp4==2){

                // }
            }


            //      mp4.play()
        },
        stopmusic() {
            let audio = document.getElementById("audio");
            if (this.music == true) {
                this.music = false;
                audio.pause();

            } else {
                this.music = true;
                // audio.volume = 0.2;
                audio.play();
            }
        },
        theagain() {
            location.reload();
        }

    },
    mounted() {
        // window.addEventListener("scroll", this.scrolling)
        setTimeout(() => {
            this.thebut = true
        }, 1500);
        const mp4 = document.getElementById("mp4");

        var that = this
        mp4.addEventListener(
            "ended",
            function () {
                //结束
                // if (that.themp4 == 1) {
                    that.step = 2
                    console.log("播放结束");
                    document.getElementById("audio").play()
                    window.addEventListener("scroll", that.scrolling)
                // }

                // if (that.themp4 == 2) {
                //     that.ifend = true
                // }



            },
            false
        );
    },
}
</script>

<style lang="less">
.home {
    width: 100%;
    height: 100%;
    position: relative;

    .homebg {
        width: 375px;
        height: 100vh;
        background: url("../static/homebg.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
        z-index: 10;


        .but {
            position: absolute;
            width: 110px;
            top: 500px;
            margin-left: -55px;
            left: 50%;
            animation: thebut 1.5s linear infinite;

            @keyframes thebut {
                0% {
                    transform: scale(1);
                }

                50% {
                    transform: scale(1.1);
                }

                100% {
                    transform: scale(1);
                }
            }
        }

        .loding {
            position: absolute;
            width: 300px;
            left: 50%;
            margin-left: -150px;
            top: 280px;
        }
    }

    .mp4-box {
        position: fixed;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: 50;


        .mp4 {
            object-fit: fill;
            width: 100%;
            height: 100vh;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }

        .skip {
            position: absolute;
            width: 70px;
            top: 30px;
            right: 20px;
            z-index: 66;
        }

      

      
    }

    .content-box {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;

        .content {
            width: 100%;
            height: 100vh;
            position: relative;

            .content_bg {
                // position: absolute;
                // top: 0;
                // left: 0;
                width: 100%;
                display: block;
            }

            .music {
                position: fixed;
                top: 15px;
                right: 15px;
                width: 50px;
                z-index: 21;
                transform: rotate(250deg);

                &.zhuan {
                    animation: turn 2s linear infinite;

                    @keyframes turn {
                        0% {
                            -webkit-transform: rotate(0deg);
                        }

                        25% {
                            -webkit-transform: rotate(90deg);
                        }

                        50% {
                            -webkit-transform: rotate(180deg);
                        }

                        75% {
                            -webkit-transform: rotate(270deg);
                        }

                        100% {
                            -webkit-transform: rotate(360deg);
                        }
                    }
                }
            }

            .title {
                position: absolute;
                width: 320px;
                top: 80px;
                left: 50%;
                margin-left: -160px;
                animation: title-ani 3s ease 1 forwards;

                @keyframes title-ani {
                    0% {

                        transform: scale(0.1);
                        opacity: 0;

                    }

                    100% {
                        transform: scale(1);
                        opacity: 1;
                    }
                }
            }

            .the1 {
                position: absolute;
                width: 320px;
                top: 490px;
                left: 50%;
                margin-left: -160px;
                animation: the1-ani 2s ease 1 forwards;

                @keyframes the1-ani {
                    0% {

                        top: 520px;
                        opacity: 0;

                    }

                    100% {
                        top: 490px;
                        opacity: 1;
                    }
                }
            }

            @keyframes show-ani {
                0% {

                    left: 70px;
                    opacity: 0;

                }

                100% {
                    left: 27px;
                    opacity: 1;
                }
            }

            @keyframes show2-ani {
                0% {

                    left: 70px;
                    opacity: 0;

                }

                100% {
                    left: 17px;
                    opacity: 1;
                }
            }

            .tobottom {
                position: absolute;
                width: 50px;
                right: 10px;
                top: 500px;
                z-index: 2;
            }

            .p1-1 {
                position: absolute;
                width: 310px;
                left: 27px;
                top: 660px;
                animation: show-ani 1s ease 1 forwards;
            }

            .p1-2 {
                position: absolute;
                width: 310px;
                left: 27px;
                top: 980px;
                animation: show-ani 1s ease 1 forwards;
            }

            .p1-3 {
                position: absolute;
                width: 310px;
                left: 27px;
                top: 1300px;
                animation: show-ani 1s ease 1 forwards;
            }

            .the2 {
                position: absolute;
                width: 320px;
                top: 1600px;
                left: 50%;
                margin-left: -160px;
                animation: the2-ani 2s ease 1 forwards;

                @keyframes the2-ani {
                    0% {

                        top: 1630px;
                        opacity: 0;

                    }

                    100% {
                        top: 1600px;
                        opacity: 1;
                    }
                }
            }

            .p2-1 {
                position: absolute;
                width: 310px;
                left: 27px;

                top: 1900px;
                animation: show-ani 1s ease 1 forwards;

            }

            .photo-box {
                position: absolute;
                width: 100%;
                height: 150px;
                overflow: hidden;
                left: 0;
                top: 2000px;


                .box {
                    display: flex;
                    flex-direction: row-reverse;
                    // justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
                    //  align-content:center;
                    position: absolute;
                    animation: bg-ani 20s linear infinite alternate;

                    @keyframes bg-ani {
                        from {
                            left: 0;
                        }

                        to {
                            left: -180%;
                        }
                    }

                    .p2-1-1 {
                        height: 150px;
                        display: block;
                    }
                }




            }

            .p2-2 {
                position: absolute;
                width: 310px;
                left: 27px;
                top: 2180px;
                animation: show-ani 1s ease 1 forwards;
            }

            .p2-3 {
                position: absolute;
                width: 310px;
                left: 27px;
                top: 2330px;
                animation: show-ani 1s ease 1 forwards;
            }

            .the3 {
                position: absolute;
                width: 320px;
                top: 2580px;
                left: 50%;
                margin-left: -160px;
                animation: the3-ani 2s ease 1 forwards;

                @keyframes the3-ani {
                    0% {

                        top: 2610px;
                        opacity: 0;

                    }

                    100% {
                        top: 2580px;
                        opacity: 1;
                    }
                }
            }

            .p3-1 {
                position: absolute;
                width: 310px;
                left: 27px;

                top: 2840px;
                animation: show-ani 1s ease 1 forwards;

            }

            .p3-2 {
                position: absolute;
                width: 310px;
                left: 17px;

                top: 3380px;
                animation: show2-ani 1s ease 1 forwards;

            }

            .photo-box2 {
                position: absolute;
                width: 100%;
                height: 150px;
                overflow: hidden;
                left: 0;
                top: 3670px;


                .box {
                    display: flex;
                    flex-direction: row-reverse;
                    // justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
                    //  align-content:center;
                    position: absolute;
                    animation: bg-ani2 15s linear infinite alternate;

                    @keyframes bg-ani2 {
                        from {
                            left: 10%;
                        }

                        to {
                            left: -115%;
                        }
                    }

                    .p3-2-1 {
                        height: 150px;
                        display: block;
                    }
                }




            }

            .p3-3 {
                position: absolute;
                width: 310px;
                left: 27px;

                top: 3840px;
                animation: show-ani 1s ease 1 forwards;

            }

            .the4 {
                position: absolute;
                width: 320px;
                top: 4330px;
                left: 50%;
                margin-left: -160px;
                animation: the4-ani 2s ease 1 forwards;

                @keyframes the4-ani {
                    0% {

                        top: 4360px;
                        opacity: 0;

                    }

                    100% {
                        top: 4330px;
                        opacity: 1;
                    }
                }
            }

            .p4-1 {
                position: absolute;
                width: 310px;
                left: 27px;

                top: 4470px;
                animation: show-ani 1s ease 1 forwards;

            }

            .photo-box3 {
                position: absolute;
                width: 100%;
                height: 150px;
                overflow: hidden;
                left: 0;
                top: 4700px;


                .box {
                    display: flex;
                    flex-direction: row-reverse;
                    // justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
                    //  align-content:center;
                    position: absolute;
                    animation: bg-ani3 25s linear infinite alternate;

                    @keyframes bg-ani3 {
                        from {
                            left: 10%;
                        }

                        to {
                            left: -190%;
                        }
                    }

                    .p4-1-1 {
                        height: 150px;
                        display: block;
                    }
                }




            }

            .p4-2 {
                position: absolute;
                width: 310px;
                left: 27px;

                top: 5020px;
                animation: show-ani 1s ease 1 forwards;

            }

              .againbut {
            position: absolute;
            width: 120px;
            top: 5480px;
            left: 55%;
           
        }

        .sharebut {
            position: absolute;
            width: 120px;
            top: 5480px;
            left: 15%;
         
        }

        .theend{
            position: absolute;
            width: 70px;
            left: 50%;
            margin-left: -35px;
            top: 5450px;
        }
        .bottomlogo{
              position: absolute;
            width: 160px;
            left: 50%;
            margin-left: -80px;
            top: 5550px;

        }

            .tomp4box {
                position: absolute;
                width: 150px;
                left: 50%;
                margin-left: -75px;
                top: 5450px;
            }
              .share-box {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 99;
            background-color: rgba(0, 0, 0, 0.619);
            width: 100%;
            height: 100vh;

            .share-tips {
                position: absolute;
                width: 340px;
                left: 20px;
                top: 50px;
            }
        }
        }
    }
}
</style>